import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';

import { SalesforceFieldService } from './salesforce-form/salesforce-field/salesforce-field-control.service';
import { SalesforceLaneComponent } from './salesforce-lane.component';
import { SalesforceErrorComponent } from './salesforce-error/salesforce-error.component';
import { SalesforceErrorService } from './salesforce-error/salesforce-error.service';
import { SalesforceFormComponent } from './salesforce-form/salesforce-form.component';
import { SalesforceFieldComponent } from './salesforce-form/salesforce-field/salesforce-field.component';
import { SalesforceReferenceFieldComponent } from './salesforce-form/salesforce-field/salesforce-reference-field/salesforce-reference-field.component';
import { SalesforceMultiPicklistModule } from './salesforce-form/salesforce-field/salesforce-multipicklist-field/salesforce-multipicklist-field.module';
import { SalesforceSharedModule } from './shared/salesforce-shared.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { LoadingModule } from 'shared/components/loading/loading.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild(),
    ReactiveFormsModule,
    NgbModule,
    TextMaskModule,
    LoadingModule,
    SalesforceMultiPicklistModule,
    FormsModule,
    SalesforceSharedModule
  ],
  providers: [
    SalesforceFieldService,
    SalesforceErrorService
  ],
  declarations: [
    SalesforceLaneComponent,
    SalesforceErrorComponent,
    SalesforceFormComponent,
    SalesforceFieldComponent,
    SalesforceReferenceFieldComponent
  ],
  exports: [
    SalesforceLaneComponent
  ]
})
export class SalesforceLaneModule {}
